import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_ALARM_CLOCK_CHECK: GlameraIconDefinition = {
  name: 'alarm-clock-check',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-alarm-clock-check-body">
      <circle cx="12" cy="13" r="8"></circle>
      <path d="M5 3 2 6"></path>
      <path d="m22 6-3-3"></path>
      <path d="M6.38 18.7 4 21"></path>
      <path d="M17.64 18.67 20 21"></path>
      <path class="glm-alarm-clock-check-tick" pathLength="1" d="m9 13 2 2 4-4"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-alarm-clock-check-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './alarm-clock-check.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AlarmClockCheckIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_ALARM_CLOCK_CHECK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
